module.exports = __webpack_public_path__ + "static/media/icon-maps.3eab0981.svg";